import React from "react";
import { useNavigate } from "react-router-dom";
import { AiOutlineDownload } from "react-icons/ai";


const Course = ({ course,convocationNumber,handleDownloadCertificates }) => {

return (
  <div      
    className={`w-[180px] h-[180px] cursor-pointer shadow-md rounded-lg flex flex-col items-center justify-center text-gray-800 border border-gray-300 
      ${course.applied === 'YES' ? 'bg-green-200' : 'bg-pink-200'}
      transition-transform duration-300 ease-in-out transform hover:scale-105 hover:shadow-lg hover:bg-blue-700 hover:text-white`}
  >
    <p className="w-full text-xs text-center font-semibold mb-2">
      {course.applied === 'YES' ? 'APPLIED' : 'NOT_APPLIED'}
    </p>
    <p className="w-full text-xs text-center font-semibold mb-2">{course.type}</p>
    <p className="w-full text-xs text-center font-semibold mb-2">{course.batch}</p>
    <p className="w-full text-sm text-center mb-3 font-semibold">
      {course.students.length} <span className="text-xs">STUDENTS</span>
    </p>
                         <button 
                         onClick={() => handleDownloadCertificates(convocationNumber, course.batch, course.type, course.applied,'YES',course.students.map(s => s._id))}
                          className="flex items-center text-xs gap-2 bg-orange-600 text-white px-2 py-1 rounded-lg hover:bg-orange-700 transition duration-200"
                        >
                          <AiOutlineDownload size={20} />
                          Download with BG
                        </button>

                        <button 
                         onClick={() => handleDownloadCertificates(convocationNumber, course.batch, course.type, course.applied,'NO',course.students.map(s => s._id))}
                          className=" mt-2 flex items-center text-xs gap-2 bg-gray-600 text-white px-2 py-1 rounded-lg hover:bg-gray-700 transition duration-200"
                        >
                          <AiOutlineDownload size={20} />
                          Download Plain
                        </button>
  </div>
);


};

export default Course;
